/**
 * Copyright (c) 2023 - Fuxlabs Vietnam Limited
 *
 * @author  NNTruong / nhuttruong6496@gmail.com
 */
import React from 'react';
import { Box } from '@mui/material';
export default function Index({
  color,
  size,
  width = '24px',
  height = '24px',
  ...other
}) {
  return (
    <Box
      component="svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      {...other}
      color={color ? color : 'primaryText'}
    >
      <path
        d="M5.97 1H3.03C1.76 1 1 1.76 1 3.03V5.97C1 7.24 1.76 8 3.03 8H5.97C7.24 8 8 7.24 8 5.97V3.03C8 1.76 7.24 1 5.97 1ZM6.47 5.56C6.72 5.81 6.72 6.22 6.47 6.47C6.34 6.59 6.17 6.65 6.01 6.65C5.85 6.65 5.69 6.59 5.56 6.47L4.49 5.41L3.45 6.47C3.32 6.59 3.16 6.65 2.98 6.65C2.82 6.65 2.66 6.59 2.53 6.47C2.28 6.22 2.28 5.81 2.53 5.56L3.6 4.5L2.54 3.45C2.29 3.2 2.29 2.79 2.54 2.54C2.79 2.29 3.2 2.29 3.45 2.54L4.49 3.6L5.55 2.54C5.8 2.29 6.21 2.29 6.46 2.54C6.71 2.79 6.71 3.2 6.46 3.45L5.41 4.5L6.47 5.56Z"
        fill="currentColor"
      />
      <path
        d="M21.4999 15.8199C21.4999 15.9699 21.4499 16.1199 21.3199 16.2499C19.8699 17.7099 17.2899 20.3099 15.8099 21.7999C15.6799 21.9399 15.5099 21.9999 15.3399 21.9999C15.0099 21.9999 14.6899 21.7399 14.6899 21.3599V17.8599C14.6899 16.3999 15.9299 15.1899 17.4499 15.1899C18.3999 15.1799 19.7199 15.1799 20.8499 15.1799C21.2399 15.1799 21.4999 15.4899 21.4999 15.8199Z"
        fill="currentColor"
      />
      <path
        d="M21.4999 15.8199C21.4999 15.9699 21.4499 16.1199 21.3199 16.2499C19.8699 17.7099 17.2899 20.3099 15.8099 21.7999C15.6799 21.9399 15.5099 21.9999 15.3399 21.9999C15.0099 21.9999 14.6899 21.7399 14.6899 21.3599V17.8599C14.6899 16.3999 15.9299 15.1899 17.4499 15.1899C18.3999 15.1799 19.7199 15.1799 20.8499 15.1799C21.2399 15.1799 21.4999 15.4899 21.4999 15.8199Z"
        fill="currentColor"
      />
      <path
        d="M16.63 2H10.5C9.95 2 9.5 2.45 9.5 3V6.5C9.5 8.16 8.16 9.5 6.5 9.5H3.5C2.95 9.5 2.5 9.95 2.5 10.5V17.13C2.5 19.82 4.68 22 7.37 22H12.19C12.74 22 13.19 21.55 13.19 21V17.86C13.19 15.56 15.1 13.69 17.45 13.69C17.98 13.68 19.27 13.68 20.5 13.68C21.05 13.68 21.5 13.24 21.5 12.68V6.87C21.5 4.18 19.32 2 16.63 2ZM8.72 17.01H6.08C5.67 17.01 5.33 16.67 5.33 16.26C5.33 15.84 5.67 15.5 6.08 15.5H8.72C9.15 15.5 9.47 15.84 9.47 16.26C9.47 16.67 9.15 17.01 8.72 17.01ZM11.51 13.3H6.08C5.67 13.3 5.33 12.96 5.33 12.55C5.33 12.13 5.67 11.79 6.08 11.79H11.51C11.92 11.79 12.27 12.13 12.27 12.55C12.27 12.96 11.92 13.3 11.51 13.3Z"
        fill="currentColor"
      />
    </Box>
  );
}
